import { render } from "./MiFile.vue?vue&type=template&id=b88eca18&scoped=true"
import script from "./MiFile.vue?vue&type=script&lang=js"
export * from "./MiFile.vue?vue&type=script&lang=js"

import "./MiFile.vue?vue&type=style&index=0&id=b88eca18&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b88eca18"]])

export default __exports__
import QFile from 'quasar/src/components/file/QFile.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QFile,QField});
